import { TileActions } from "components/dynamic-content/util/dynamicContent"
import Tile from "components/views/atoms/Tile"
import { ITile } from "contentful-types"
import React, { ReactElement } from "react"
import { ContentfulConditionalGate } from "./ContentfulConditionGate"
import { fieldIsValid, getIconUrl, getTileOnClick } from "../utils/mappingUtils"

type TileElementProps = {
  tile: ITile
  actions: TileActions
  baseUrl: string
}

const TileElement = ({ tile, actions, baseUrl }: TileElementProps): ReactElement<typeof Tile> => {
  const {
    fields: { display, conditions }
  } = tile

  if (!fieldIsValid(display)) {
    return null
  }

  const {
    fields: { title, description, icon, secondaryDescription }
  } = display

  return (
    <ContentfulConditionalGate conditions={conditions}>
      <Tile
        title={title}
        description={description}
        secondaryDescription={secondaryDescription}
        iconUrl={getIconUrl(icon)}
        onClick={getTileOnClick({ tile, actions, baseUrl })}
      />
    </ContentfulConditionalGate>
  )
}

export { TileElement }
